export default __webpack_public_path__ + "static/media/superpy.63e62ca2.png";